import { CORE_OAUTH, CORE_PLUGIN, CORE_ROUTER } from "@/core"
import type { Plugin } from "@/plugins"
import { injectOptional } from "@/tsyringe-extend"
import { defineStore } from "pinia"
import { container, injectable, instanceCachingFactory, registry, singleton } from "tsyringe"
import type { App } from "vue"
import type { Router } from "vue-router"
import AutoSignin from './wechat/AutoSignin.vue'
import CreateOneByMobileOrSigninBinding from './wechat/CreateOneByMobileOrSigninBinding.vue'
import WechatError from './wechat/WechatError.vue'
import Wechat from './wechat/WechatOauth2.vue'
import WechatScan from './wechat/WechatScan.vue'
import AbroadRouterSign from './abroad/Index.vue'
import AbroadSignin from './abroad/AbroadSignin.vue'
import AboradTwitterCallback from './abroad/twitter/index.vue'
import AboradGoogleCallback from './abroad/google/index.vue'


export interface Oauth2ThirdPartyOptions {
  abroadAuth: boolean
  wechat: {
    appId?: string
    scanRedirect?: string
    cookieKey: string
    avatarCookieKey: string
    usernameCookieKey: string
    userInfoCookieKey: string
  }
  twitter: {
    redirectUrl: string
    clientId: string
    clientSecret: string
  }
}

export interface Oauth2Options {
  providers: Oauth2ThirdPartyOptions
  apiPort: number
  decoratorComponentName?: string
}

export const Oauth2PluginOptionsInjectKey = 'Oauth2PluginOptionsInjectKey'

export const useOauth2 = defineStore('oauth2', {
  state: () => ({
  } as Oauth2Options),
  getters: {},
  actions: {}
})

@singleton()
@registry([
  {
    token: CORE_PLUGIN,
    useFactory: instanceCachingFactory<Plugin<Oauth2Options, unknown>>((c) =>
      c.resolve(Oauth2Plugin)
    ),
  },
])
@injectable()
export class Oauth2Plugin implements Plugin<Oauth2Options, unknown> {
  id: string | symbol = ''
  options: Oauth2Options
  service: unknown
  constructor(@injectOptional(Oauth2PluginOptionsInjectKey)
  options?: Partial<Oauth2Options>) {
    const oauth2State = useOauth2()
    this.options = oauth2State.$state
    if (options) {
      oauth2State.$patch(options)
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  init(app: App<Element>): void {
    container.register<Oauth2Options>(CORE_OAUTH, { useValue: this.options })
    const router = container.resolve<Router>(CORE_ROUTER)
    if (!this.options?.providers?.abroadAuth) {
      // WeChat loginPlugin
      app.component('IotaDefaultOauth2Wechat', Wechat)
      router.addRoute({ path: '/oauth2/third_parties/wechat', component: WechatScan })
      router.addRoute({ path: '/oauth2/third_parties/wechat/error', component: WechatError })
      router.addRoute({ path: '/oauth2/third_parties/wechat/auto', component: AutoSignin })
      router.addRoute({ path: '/oauth2/third_parties/wechat/new', component: CreateOneByMobileOrSigninBinding })
    } else {
      app.component('IotaDefaultOauth2Wechat', AbroadRouterSign)
      router.addRoute({ path: '/oauth2/third_parties/abroadSignin', component: AbroadSignin })
      router.addRoute({ path: '/oauth2/third_parties/abroadSignin/twitter/callback', component: AboradTwitterCallback })
      router.addRoute({ path: '/oauth2/third_parties/abroadSignin/google/callback', component: AboradGoogleCallback })
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  initialized(app: App<Element>): void {

  }
}
